import React from "react";
import ServicesCards from "./ServicesCards";
import { useState } from "react";
import { motion } from "framer-motion";


const servicesData = [
  {
    name: "Public Health Engineerin og",
    details:[
      "Conceptual / P & I Drawing Showing location of all Plumbing Utilities viz. STP, UGWT, OHT, OWC.",
      "Sewerage Layout.",
      "Storm Water Layout",
      "Toilet Layout",
      "Underground and Overhead Tank Layout along with sleeve details",
      "Terrace Rain Water Layout",
      "Hydro pneumatic System Details",
      "Rising Main Layout",
      "Rain Water Harvesting. Tender along with Technical Specifications"
    ]
  },
  {
    name: "Electrical System",
    details: [
      "Complete design of internal & external installation, working of power load as per user’s requirements. Preparation of detailed budget",
      "•Design of sizes of cables, transformer, HV/LV panels etc.",
      "Co-ordination with Architect / Landscape consultants as well with your office",
      "•Preparation of Tenders /call RFQ’s, finalization of contracts and negotiation with the contractors / suppliers, to control investment in electrical works as per budget /requirements.",
      "•Generator selection, testing & preparation of various auto change-over schemes.",
      "•Design of building automation system, LAN / Wi-Fi connectivity on internet.",
      "Consulting in improvement of power factor of bulk consumers and reduction in harmonics. Periodic site inspections & quality check on workmanship of contractor.",
      "•Assisting in purchasing better quality material at economical rates.",
      "•Space planning for economic design for layout of transformer, energy metering panel / boxes etc.",
      "Check R.A. / Final Bill of electrical contractors and justifying the same with respect to work done.",
      "Ensuring the completion of work for safety and No Compliant from end user.",
      "Issue of Blue Prints to contractors, architects/Electrical Inspector, Site Engineers, State Electricity Board and finally to users/property managers.",
      "Assisting Electrical contractors in technical discussion with local electricity boards for power load sanction/ approvals.",
      "Testing of installations done by electrical contractor"
    ]
  },
  {
    name: "Fire Fighting & Alarm System",
    details: [
      "This Includes Design and Drawing of al following systems as per PMC by laws, National Building Code , TAC Rules and relevant codes.",
      "Court Yard Hydrant Layout",
      "Fire Alarm System.",
      "Shaft Details",
      "Fire Alarm Layout.",
      "Sprinkler Layout.",
      "Underground Tank Layout.",
      "Tender along with Technical Specifications."
    ]
  },
  {
    name: "Industrial Piping",
    details: [
      "This Includes Design and Drawing of all following systems as per PMC by laws, National Building Code, TAC Rules and relevant codes.",
      "Cooling Water Systems.",
      "Compressed Air Piping System.",
      "LDO Piping System.",
      "LPG Piping System."
    ]
  },
  {
    name: "CCTV Surveillance, Access Control & Networking",
    details: [
      "This Includes Design and Drawing of all following systems as per relevant codes.",
      "Preparation of I/O Summary",
      "Structured cabling and network design."
    ]
  },
  {
    name: "Building Automation System",
    details: [
      "This Includes Design all following systems.",
      "CCTV Surveillance System",
      "Access Control System",
      "Computer Networking",
      "Intrusion / Security System",
      "PA System"
    ]
  },
  {
    name: "HVAC System",
    details: [
      "School & Institutional Project",
      "Residential",
      "Business Buildings (IT Park, Office Buildings)",
      "Commercial Buildings (Shopping Malls, Multiplex etc.)",
      "Auditorium",
      "Industrial & Automobile Sector",
      "Hotels",
      "Hospitals",
      "Institutes"
    ]
  },
  {
    name: "Renewable Energy using Solar System",
    details: [
      "School & Institutional Project",
      "Residential",
      "Business Buildings (IT Park, Office Buildings)",
      "Commercial Buildings (Shopping Malls, Multiplex etc.)",
      "Auditorium",
      "Industrial & Automobile Sector",
      "Hotels",
      "Hospitals",
      "Institutes"
    ]
  }
];

const Services3 = ({ noMargin }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalIdx, setModalIdx] = useState(null);

  const handleViewMore = (idx) => {
    setModalIdx(idx);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalIdx(null);
  };

  // Animation variants
  // Animation variants for on-scroll
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.35,
        delayChildren: 0.1,
      },
    },
  };
  const leftPanel = {
    hidden: { opacity: 0, x: -180 },
    show: {
      opacity: 1, x: 0,
      transition: { duration: 1.4, ease: [0.16, 1, 0.3, 1] }
    }
  };
  const rightPanel = {
    hidden: { opacity: 0, x: 180 },
    show: {
      opacity: 1, x: 0,
      transition: { duration: 1.4, ease: [0.16, 1, 0.3, 1] }
    }
  };

  return (
    <div style={{ position: "relative", minHeight: "100vh" }}>
      {/* Video Background for only this page and all content */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
          opacity: 0.5,
          pointerEvents: "none",
          background: "#0A1931"
        }}
        aria-hidden="true"
      >
        <source src={ "/video2.mp4"} type="video/mp4" />
      </video>
      <motion.div
        style={{ minHeight: "60vh", color: "#fff", overflowX: "hidden", position: "relative", zIndex: 1, ...(noMargin ? {} : { marginTop: "90px" }) }}
        initial={noMargin ? "hidden" : false}
        whileInView={noMargin ? "show" : false}
        viewport={noMargin ? { once: false, amount: 0.2 } : undefined}
        variants={noMargin ? containerVariants : undefined}
      >
        <style>
          {`
            @keyframes moveBgLeftRight {
              0% { background-position: center; }
              50% { background-position: left 20px center; }
              100% { background-position: center; }
            } 
          `}
        </style>
        {/* Centered Heading */}
        <div className="w-full flex flex-col items-center justify-center mb-8 mt-8">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight text-center" style={{letterSpacing: "1px"}}>OUR SERVICES</h1>
        </div>
        <div className="services-responsive-container flex flex-col md:flex-row items-start justify-between pt-0 md:pt-8 max-w-[1600px] mx-auto w-full">
          {/* Left Panel */}
          <motion.div
            className="services-left-panel flex-1 px-4 md:px-16 flex flex-col justify-center items-center mb-8 md:mb-0"
            style={{height: "auto"}}
            variants={noMargin ? leftPanel : undefined}
            initial={noMargin ? "hidden" : false}
            whileInView={noMargin ? "show" : false}
            viewport={noMargin ? { once: false, amount: 0.2 } : undefined}
          >
            <p className="text-lg sm:text-xl md:text-2xl text-white mt-4 mb-8 max-w-xl leading-snug opacity-90 text-center">
              We undertake consultancy services in various streams of engineering
            </p>
            {/* Removed services list from left panel as requested */}
          </motion.div>
          {/* Right Panel */}
          <motion.div
            className="services-right-panel flex-1 px-4 md:px-16 flex flex-col justify-center items-start"
            style={{height: "auto"}}
            variants={noMargin ? rightPanel : undefined}
            initial={noMargin ? "hidden" : false}
            whileInView={noMargin ? "show" : false}
            viewport={noMargin ? { once: false, amount: 0.2 } : undefined}
          >
            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-4" style={{letterSpacing: "0.5px"}}>Services List</h2>
            <ul className="text-base sm:text-lg md:text-xl text-gray-200 mt-0 mb-8 max-w-xl leading-relaxed list-disc list-inside w-full">
              {servicesData.map((service, idx) => (
                <motion.li
                  key={idx}
                  variants={noMargin ? rightPanel : undefined}
                  initial={noMargin ? "hidden" : false}
                  whileInView={noMargin ? "show" : false}
                  viewport={noMargin ? { once: false, amount: 0.2 } : undefined}
                >
                  {service.name}
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </motion.div>
      <div style={{ position: "relative", zIndex: 1 }}>
        <ServicesCards services={servicesData} onViewMore={handleViewMore} selectedIdx={modalIdx} animateOnScroll={noMargin} />
        {modalOpen && modalIdx !== null && (
          <ModalDetails service={servicesData[modalIdx]} onClose={handleCloseModal} />
        )}
      </div>
    </div>
  );
}

// ModalDetails component
function ModalDetails({ service, onClose }) {
  if (!service) return null;
  // Prevent modal close when clicking inside the modal
  const handleModalClick = (e) => {
    e.stopPropagation();
  };
  return (
    <>
      {/* Overlay */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.6)",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: "modalFadeIn 0.5s cubic-bezier(0.23,1,0.32,1)"
        }}
        onClick={onClose}
      >
        <style>
          {`
            @keyframes modalFadeIn {
              0% { opacity: 0; transform: scale(0.92); }
              100% { opacity: 1; transform: scale(1); }
            }
          `}
        </style>
        <div
          style={{
            background: "#222",
            color: "#fff",
            borderRadius: "16px",
            padding: "40px 32px",
            minWidth: "340px",
            maxWidth: "480px",
            width: "100%",
            boxShadow: "0 8px 40px 0 rgba(0,0,0,0.25), 0 0 48px 12px rgba(0,123,255,0.75)",
            textAlign: "center",
            animation: "modalFadeIn 0.5s cubic-bezier(0.23,1,0.32,1)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
          onClick={handleModalClick}
        >
          <h2 style={{ fontSize: "28px", marginBottom: "18px" }}>{service.name} - Details</h2>
          <div style={{
            maxHeight: "320px",
            overflowY: "auto",
            width: "100%",
            marginBottom: "24px",
            paddingRight: "4px"
          }}>
            <ul style={{
              fontSize: "16px",
              color: "#ccc",
              textAlign: "left",
              paddingLeft: 24,
              listStyleType: "disc",
              listStylePosition: "inside",
              margin: 0,
              display: "flex",
              flexDirection: "column",
              gap: "12px"
            }}>
              {Array.isArray(service.details)
                ? service.details.map((point, i) => <li key={i}>{point}</li>)
                : <li>{service.details}</li>}
            </ul>
          </div>
          <button
            style={{
              background: "#fff",
              color: "#222",
              border: "none",
              borderRadius: "6px",
              padding: "6px 18px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 500,
              marginRight: "12px"
            }}
            onClick={onClose}
          >
            Back
          </button>
        </div>
      </div>
    </>
  );
}

export default Services3;
